// extracted by mini-css-extract-plugin
export var fullWidthButton = "_eu-0";